export default __webpack_public_path__ + "static/media/hero.9700669c.jpg";